import { VersionCopsoq3Enum } from "../../../convex/schema";

export { VersionCopsoq3Enum };

/**
 * Catalogue des versions du COPSOQ III. Toutes partagent la partie 2 (54
 * questions scorées, mêmes échelles et domaines) ; seules les formulations
 * changent, et certaines ajoutent les parties 1 (profil) et 3 (santé). Le
 * contenu de chaque version (questions, écrans) est dans le formulaire :
 * `apps/form/src/templates/copsoq3/copsoq3-versions.ts`.
 *
 * Ajouter une version : une valeur de `VersionCopsoq3Enum` (et du validator),
 * une entrée ici, son questionnaire dans `copsoq3-versions.ts`.
 */
export interface VersionCopsoq3Config {
  cle: VersionCopsoq3Enum;
  libelle: string;
}

export const VERSIONS_COPSOQ3: readonly VersionCopsoq3Config[] = [
  { cle: VersionCopsoq3Enum.UNIVERSELLE, libelle: "Universelle" },
  { cle: VersionCopsoq3Enum.POMPIERS, libelle: "Sapeurs-pompiers" },
];

/** Version d'une organisation qui n'en a pas choisi. */
export const VERSION_COPSOQ3_PAR_DEFAUT = VersionCopsoq3Enum.UNIVERSELLE;

/**
 * Version d'une campagne ou d'une passation qui n'en porte pas : elle date
 * d'avant les versions, quand seule la version pompiers était proposée.
 */
export const VERSION_COPSOQ3_HISTORIQUE = VersionCopsoq3Enum.POMPIERS;

export function versionCopsoq3(cle: VersionCopsoq3Enum): VersionCopsoq3Config {
  const config = VERSIONS_COPSOQ3.find((v) => v.cle === cle);
  if (!config) throw new Error(`Version COPSOQ III inconnue : ${cle}`);
  return config;
}

/** Version des campagnes à venir d'une organisation. */
export function versionCopsoq3DeOrganisation(org: {
  versionCopsoq3?: VersionCopsoq3Enum;
}): VersionCopsoq3Enum {
  return org.versionCopsoq3 ?? VERSION_COPSOQ3_PAR_DEFAUT;
}

/** Version d'une passation (ou d'une entrée de campagne) COPSOQ III. */
export function versionCopsoq3DeDonnees(donnees: {
  versionCopsoq3?: VersionCopsoq3Enum;
}): VersionCopsoq3Enum {
  return donnees.versionCopsoq3 ?? VERSION_COPSOQ3_HISTORIQUE;
}
